import { Shield } from "lucide-react";

/**
 * Founder Badge Component
 * Displays the "DealForge Founder" badge for beta users
 * 
 * Usage:
 * <FounderBadge show={user.has_founder_badge} />
 */
export function FounderBadge({ show, size = "sm", className = "" }) {
  if (!show) return null;

  const sizes = {
    xs: {
      container: "px-1.5 py-0.5 gap-1",
      icon: "w-3 h-3",
      text: "text-[9px]"
    },
    sm: {
      container: "px-2 py-1 gap-1.5",
      icon: "w-3.5 h-3.5",
      text: "text-[10px]"
    },
    md: {
      container: "px-3 py-1.5 gap-2",
      icon: "w-4 h-4",
      text: "text-xs"
    },
    lg: {
      container: "px-4 py-2 gap-2",
      icon: "w-5 h-5",
      text: "text-sm"
    }
  };

  const s = sizes[size] || sizes.sm;

  return (
    <div 
      className={`inline-flex items-center ${s.container} bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full ${className}`}
      title="DealForge Founder - Early platform adopter with locked founder pricing"
    >
      <Shield className={`${s.icon} text-[#D4AF37]`} />
      <span className={`${s.text} font-semibold text-[#D4AF37] uppercase tracking-wider`}>
        Founder
      </span>
    </div>
  );
}

/**
 * Founder Badge with full label
 */
export function FounderBadgeFull({ show, className = "" }) {
  if (!show) return null;

  return (
    <div 
      className={`inline-flex items-center gap-2 px-3 py-1.5 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded ${className}`}
      title="Early platform adopter with locked founder pricing"
    >
      <Shield className="w-4 h-4 text-[#D4AF37]" />
      <span className="text-xs font-semibold text-[#D4AF37]">
        DealForge Founder
      </span>
    </div>
  );
}

/**
 * Pricing Tier Badge
 * Shows the user's pricing tier (Founder or Standard)
 */
export function PricingTierBadge({ tier, className = "" }) {
  if (tier === "beta_founder") {
    return <FounderBadge show={true} className={className} />;
  }

  return (
    <div 
      className={`inline-flex items-center px-2 py-1 bg-white/5 border border-white/10 rounded-full ${className}`}
    >
      <span className="text-[10px] font-medium text-white/60 uppercase tracking-wider">
        Standard
      </span>
    </div>
  );
}

export default FounderBadge;
